(() => {
  'use strict';

  const makerName = (block) => block
    .querySelector('.mb-author-head h3, .mb-illustrator-head h3')
    ?.textContent.trim() || '';

  const sortMakerOverview = (page) => {
    const list = page.querySelector('.mb-author-list, .mb-illustrator-list');
    if (!list) return;
    const blocks = [...list.children].filter((child) => child.matches('.mb-author-block, .mb-illustrator-block'));
    blocks.sort((a, b) => makerName(a).localeCompare(makerName(b), 'nl', {
      sensitivity: 'base',
      ignorePunctuation: true,
    }));
    blocks.forEach((block) => list.appendChild(block));
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"], .mb-page-content[data-page-handle="illustratoren"]')
      .forEach(sortMakerOverview);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
